import React, {Component} from "react";
import {epaFetchData} from "../../../actions/epa";
import {connect} from "react-redux";

class CitationAboutEpa extends Component {

    componentDidUpdate() {
        this.props.fetchData(`https://psytable-api.herokuapp.com/api/epa/${this.props.parentEpa}`);
    }


    render() {
        return (
            <section className="citation-about">
                {
                    this.props.epa.map((item, index) =>{
                        return(
                            <div className="citation-about__inner" key={index}>
                                <div className="citation-about__col">
                                    <div className="citation-about__epa">{item.abbreviation}</div>
                                    <span className="citation-about__tagline">Core Disgust</span>
                                </div>

                                <div className="citation-about__col">
                                    <div className="citation-about__item">
                                        <span className="citation-about__name">Symbol: </span>
                                        <span className="citation-about__description">{item.abbreviation}</span>
                                    </div>
                                    <div className="citation-about__item">
                                        <span className="citation-about__name">Class: </span>
                                        <span className="citation-about__description">{item.classification}</span>
                                    </div>
                                    <div className="citation-about__item">
                                        <span className="citation-about__name">Number: </span>
                                        <span className="citation-about__description">{item.number}</span>
                                    </div>
                                </div>
                                <div className="citation-about__col">
                                    <div className="citation-about__item">
                                        <span className="citation-about__name">Neurochemical Substrates: </span>
                                        <span className="citation-about__description ">{item.neurochemicalSubstrates}</span>
                                    </div>
                                    <div className="citation-about__item">
                                        <span className="citation-about__name">Neurolocalization: </span>
                                        <span className="citation-about__description ">{item.neurolocalization}</span>
                                    </div>
                                    <div className="citation-about__item">
                                        <span className="citation-about__name">Elicitors: </span>
                                        <span className="citation-about__description ">{item.elicitors}</span>
                                    </div>
                                </div>
                                <div className="citation-about__col">
                                    <div className="citation-about__item">
                                        <span className="citation-about__name">Function: </span>
                                        <span className="citation-about__description ">{item.function}</span>
                                    </div>
                                    <div className="citation-about__item">
                                        <span className="citation-about__name">Outputs: </span>
                                        <span className="citation-about__description ">{item.outputs}</span>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }

            </section>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        epa: state.epa
    };
};


const mapDispatchToProps = dispatch => {
    return {
        fetchData: url => dispatch(epaFetchData(url))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CitationAboutEpa);
